import { getAxiosInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

export const getRequestGroup = (callback, query = "") => {
  cachiosInstance.get(`/reservation/requestGroup?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateRequestGroup = (data, callback) => {
  getAxiosInstanceApi().put("/reservation/requestGroup", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getNotification = (callback) => {
  cachiosInstance.get(`/dashboard/notification`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteNotification = (notificationId, callback) => {
  getAxiosInstanceApi().delete(`/dashboard/notification/${notificationId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updatePatientInformation = (patientId, data, callback) => {
  getAxiosInstanceApi().put(`/patientInformation?patientId=${patientId}`, data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deletePatientInformation = (patientId, callback) => {
  getAxiosInstanceApi().delete(`/patientInformation/${patientId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteReservationNoteBook = (reservationNotebookId, callback) => {
  getAxiosInstanceApi().delete(`/reservation/notebook/${reservationNotebookId}`)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateReservationNoteBookStatus = (reservationNotebookId, data, callback) => {
  getAxiosInstanceApi().put(`/reservation/notebook/status/${reservationNotebookId}`, data)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservationNoteBookHistory = (reservationNotebookId, callback) => {
  getAxiosInstanceApi().get(`/reservation/notebookHistory/${reservationNotebookId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getFillTimeHistoryHistory = (fillTimeHistoryId, callback) => {
  getAxiosInstanceApi().get(`/reservation/fillTimeHistory/${fillTimeHistoryId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newRequestGroup = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/requestGroup", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newSubRequestGroup = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/subRequestGroup", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getSubRequestGroup = (requestGroupId, callback) => {
  cachiosInstance.get(`/reservation/subRequestGroup/${requestGroupId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservationFullList = (query, callback) => {
  cachiosInstance.get(`/reservation/fullList/?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservationListByDate = (query, reservationDate, callback) => {
  cachiosInstance.get(`/reservation/reservationDay/${reservationDate}/?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservationNotebookStats = (query, callback) => {
  cachiosInstance.get(`/analysis/notebook?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getPatientsDailyCount = (query, callback) => {
  cachiosInstance.get(`/analysis/patient?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getTransactionsDailyByCenter = (query, callback) => {
  cachiosInstance.get(`/analysis/transactions?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addTimeSpan = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/timeSpan", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getTimeSpan = (isActive, callback) => {
  cachiosInstance.get(`/reservation/timeSpan/${isActive}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservationDay = (todayDate, timeSpanId, callback) => {
  cachiosInstance.get(`/reservation/reservationDay/${todayDate}/${timeSpanId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getCalendar = (todayDate, callback) => {
  cachiosInstance.get(`/reservation/getCalendar/${todayDate}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};

export const getReservedCounter = (todayDate, callback) => {
  cachiosInstance.get(`/reservation/reservedCounter/${todayDate}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getMe = (callback) => {
  cachiosInstance.get(`/dashboard/me`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getTimeSpanCounter = (todayDate, callback) => {
  cachiosInstance.get(`/reservation/timeSpanCounter/${todayDate}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};

export const getReservationByDate = (reservationDate, callback) => {
  cachiosInstance.get(`/reservation/reservationDay/${reservationDate}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};

export const reservationDaysPure = (todayDate, callback) => {
  cachiosInstance.get(`/reservation/reservationDaysPure/${todayDate}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};

export const updateIsActiveTimeSpan = (data, callback) => {
  getAxiosInstanceApi().put("/reservation/isActiveTimeSpan", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateIsActiveReservationDay = (data, callback) => {
  getAxiosInstanceApi().put("/reservation/isActiveReservationDay", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteReservationDay = (reservationDayId, callback) => {
  getAxiosInstanceApi().delete(`/reservation/reservationDay/${reservationDayId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateReservationTimeSpan = (data, callback) => {
  getAxiosInstanceApi().put("/reservation/timeSpan", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addRoles = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/rules", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getRoles = (callback) => {
  cachiosInstance.get(`/reservation/rules`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateSubRequestGroup = (data, callback) => {
  getAxiosInstanceApi().put("/reservation/subRequestGroup", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newReservationDay = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/reservationDay", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const login = (data, callback) => {
  getAxiosInstanceApi().post("/dashboardUsers/login", data)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const changePassword = (data, callback) => {
  getAxiosInstanceApi().post("/dashboardUsers/changePassword", data)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservationTimesEachDay = (date, callback) => {
  cachiosInstance.get(`/reservation/reservationTimesEachDay/${date}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservedSubTimesEachDay = (date, callback) => {
  cachiosInstance.get(`/reservation/reservedSubTimesEachDay/${date}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getCenterHealthInfo = (callback) => {
  cachiosInstance.get("/reservation/centerHealthInfo")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const centerHealthInfoIsActive = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/centerHealthInfo", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateHealthInfoIsActive = (data, callback) => {
  getAxiosInstanceApi().put("/reservation/centerHealthInfo", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getPatientList = (query, callback, force = false) => {
  cachiosInstance.get(`/reservation/patientList?${query}`, { force })
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservationNoteBook = (query, callback) => {
  cachiosInstance.get(`/reservation/notebook?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservationFillTime = (query, callback) => {
  cachiosInstance.get(`/reservation/reservationFillTime?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newAdmission = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/admission", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getDashboardUsers = (callback, force = false) => {
  cachiosInstance.get(`/dashboardUsers`, { force })
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getNotebookStats = (callback) => {
  cachiosInstance.get(`/reservation/notebook-stats`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getFillTimeStats = (callback) => {
  cachiosInstance.get(`/reservation/fill-time-stats`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newDashboardUser = (data, callback) => {
  getAxiosInstanceApi().post("/dashboardUsers/center", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateDashboardUser = (userId, data, callback) => {
  getAxiosInstanceApi().put(`/dashboardUsers/center/${userId}`, data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateDashboardUserPassword = (data, callback) => {
  getAxiosInstanceApi().put(`/dashboardUsers/center-change-password`, data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteDashboardUser = (userId, callback) => {
  getAxiosInstanceApi().delete(`/dashboardUsers/${userId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getFullScenario = (date, callback) => {
  cachiosInstance.get(`/reservation/fullScenario?date=${date}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getTransition = (patientId, reservedSubTimesId, callback) => {
  cachiosInstance.get(`/transaction?patientId=${patientId}&reservedSubTimesId=${reservedSubTimesId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getPatientImage = (patientId, callback) => {
  getAxiosInstanceApi().get(`/patientsFiles/${patientId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response?.data || { message: 'دریافت تصویر نسخه ناموفق بود؛ اتصال را بررسی کنید.' });
    });
};
export const getPatientHealthInfo = (patientId, callback) => {
  cachiosInstance.get(`/patientHealthInfo/${patientId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getPayedPatientInfo = (refId, callback) => {
  cachiosInstance.get(`/patientInfo/${refId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getInsurance = (supplement, callback) => {
  cachiosInstance.get(`/reservation/insurance/${supplement}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservedDays = (requestId, subRequestId, callback) => {
  cachiosInstance.get(`/reservation/reservedDays/${requestId}/${subRequestId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservedTimes = (groupId, subGroupId, date, reservationDayId, callback) => {
  cachiosInstance.get(`/reservation/reservationTimes?groupId=${groupId}&subGroupId=${subGroupId}&date=${date}&reservationDayId=${reservationDayId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservedTimesNoDayId = (groupId, subGroupId, date, callback) => {
  cachiosInstance.get(`/reservation/reservationTimes?groupId=${groupId}&subGroupId=${subGroupId}&date=${date}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      console.log(error)
      callback(false, error.response.data);
    });
};
export const getReservedSubTimes = (requestGroupId, reservationDate, subRequestGroupId, callback, force = false) => {
  cachiosInstance.get(`/reservation/reservedSubTimes?requestGroupId=${requestGroupId}&reservationDate=${reservationDate}&subRequestGroupId=${subRequestGroupId}`, { force })
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getReservedSubTimesN = (query, callback) => {
  cachiosInstance.get(`/reservation/reservedSubTimes?${query}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getDepartmentInfo = (callback) => {
  cachiosInstance.get("/site/departmentInfo")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getHeaderInfo = (callback) => {
  cachiosInstance.get("/site/headerInfo")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getAbout = (callback) => {
  cachiosInstance.get("/site/about")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getServices = (callback) => {
  cachiosInstance.get("/site/services")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getFrequencyQuestions = (callback) => {
  cachiosInstance.get("/site/frequencyQuestions")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newFrequencyQuestions = (data, callback) => {
  getAxiosInstanceApi().post("/site/frequencyQuestions", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateHeaderInfo = (data, callback) => {
  getAxiosInstanceApi().put("/site/headerInfo", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateAbout = (data, callback) => {
  getAxiosInstanceApi().put("/site/about", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addHeaderImage = (data, callback) => {
  getAxiosInstanceApi().post("/site/headerImage", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addDepartmentLogo = (data, callback) => {
  getAxiosInstanceApi().post("/site/departmentLogo", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addAboutImage = (data, callback) => {
  getAxiosInstanceApi().post("/site/aboutImage", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteFrequencyQuestions = (fqId, callback) => {
  getAxiosInstanceApi().delete(`/site/frequencyQuestions/${fqId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newServices = (data, callback) => {
  getAxiosInstanceApi().post("/site/services", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateServices = (data, callback) => {
  getAxiosInstanceApi().put("/site/services", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateDepartmentInfo = (data, callback) => {
  getAxiosInstanceApi().put("/site/departmentInfo", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteServices = (serviceId, callback) => {
  getAxiosInstanceApi().delete(`/site/services/${serviceId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newServicesImage = (data, callback) => {
  getAxiosInstanceApi().post("/site/servicesImage", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newGalleryImage = (data, callback) => {
  getAxiosInstanceApi().post("/site/gallery", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const reserveSubTime = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/reserveSubTime", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      console.log(error);
      callback(false, error.response.data);
    });
};
export const sendPaymentLink = (data, callback) => {
  getAxiosInstanceApi().post("/aref/payment-link", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addReservedSubTimes = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/reservedSubTimes", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addReservationNoteBook = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/notebook", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateReservationNoteBook = (reservationNoteBookId, data, callback) => {
  getAxiosInstanceApi().put(`/reservation/notebook/${reservationNoteBookId}`, data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addReservedSubTimesFromPanel = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/reservedSubTimesFromPanel", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addPatientInformation = (data, callback) => {
  getAxiosInstanceApi().post("/patientInformation", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteGalleryImage = (galleryId, callback) => {
  getAxiosInstanceApi().delete(`/site/gallery/${galleryId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteComment = (commentId, callback) => {
  getAxiosInstanceApi().delete(`/site/comments/${commentId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateComment = (commentId, data, callback) => {
  getAxiosInstanceApi().put(`/site/comments/${commentId}`, data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getGalleryImage = (callback) => {
  cachiosInstance.get("/site/gallery")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getAutoReservation = (callback, force = false) => {
  cachiosInstance.get("/reservation/autoReservation", { force })
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response);
    });
};
export const getFullInsurance = (callback) => {
  cachiosInstance.get("/reservation/insurance")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newInsurance = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/insurance", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const newTicket = (data, callback) => {
  getAxiosInstanceApi().post("/ticket", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const addAutoReservation = (data, callback) => {
  getAxiosInstanceApi().post("/reservation/autoReservation", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteAutoReservation = (autoReservationId, callback) => {
  getAxiosInstanceApi().delete(`/reservation/autoReservation/${autoReservationId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const updateInsurance = (data, callback) => {
  getAxiosInstanceApi().put("/reservation/insurance", data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteInsurance = (idInsurance, callback) => {
  getAxiosInstanceApi().delete(`/reservation/insurance/${idInsurance}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getComments = (callback) => {
  cachiosInstance.get("/site/all-comments")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getContactUs = (callback) => {
  cachiosInstance.get("/site/contactUs")
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteContactUs = (contactusId, callback) => {
  getAxiosInstanceApi().delete(`/site/contactUs/${contactusId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const sendChatMessage = (data, callback) => {
  getAxiosInstanceApi().post(`/chat-message`, data)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const deleteChatMessage = (chatId, callback) => {
  getAxiosInstanceApi().delete(`/chat-message/${chatId}`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
export const getChatMessage = (callback) => {
  getAxiosInstanceApi().get(`/chat-message`)
    .then(response => {
      const data = response.data;
      callback(true, data.data);
    }).catch(error => {
      callback(false, error.response.data);
    });
};
